var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgMedicalReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 106,
    viewBox: "0 0 82 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 6.68629 2.3943 4 5.34783 4H76.6522C79.6057 4 82 6.68629 82 10V100C82 103.314 79.6057 106 76.6522 106H5.34783C2.3943 106 0 103.314 0 100V10Z",
    fill: "#2974B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11C5 9.89543 5.78623 9 6.7561 9H75.2439C76.2138 9 77 9.89543 77 11V99C77 100.105 76.2138 101 75.2439 101H6.7561C5.78623 101 5 100.105 5 99V11Z",
    fill: "#D6E8F6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 57,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 64,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 71,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79C15 78.4477 15.4477 78 16 78H52C52.5523 78 53 78.4477 53 79V80C53 80.5523 52.5523 81 52 81H16C15.4477 81 15 80.5523 15 80V79Z",
    fill: "#4B81AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35C53 41.6274 47.6274 47 41 47C34.3726 47 29 41.6274 29 35C29 28.3726 34.3726 23 41 23C47.6274 23 53 28.3726 53 35Z",
    fill: "#E23E5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 28C39.4477 28 39 28.4477 39 29V33H35C34.4477 33 34 33.4477 34 34V36C34 36.5523 34.4477 37 35 37H39V41C39 41.5523 39.4477 42 40 42H42C42.5523 42 43 41.5523 43 41V37H47C47.5523 37 48 36.5523 48 36V34C48 33.4477 47.5523 33 47 33H43V29C43 28.4477 42.5523 28 42 28H40Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3C21 1.34315 22.3431 0 24 0H58C59.6569 0 61 1.34315 61 3V10C61 11.6569 59.6569 13 58 13H24C22.3431 13 21 11.6569 21 10V3Z",
    fill: "#2974B2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMedicalReport);
export default __webpack_public_path__ + "static/media/imgMedicalReport.31602bcf250c16f0d884672e04587f98.svg";
export { ForwardRef as ReactComponent };